import React, { useState, useEffect } from 'react';
import { Keyboard } from 'lucide-react';
import {
  Modal,
  ModalHeader,
  ModalTitle,
  ModalDescription,
  ModalBody,
} from './ui/modal';

const SHORTCUTS = [
  { key: 'Ctrl + D', action: 'Dashboard' },
  { key: 'Ctrl + S', action: 'Screenshots' },
  { key: 'Ctrl + A', action: 'Applications' },
  { key: 'Ctrl + C', action: 'Clipboard' },
  { key: 'Ctrl + U', action: 'USB Activity' },
  { key: 'Ctrl + I', action: 'Incidents' },
  { key: 'Ctrl + T', action: 'Timeline' },
  { key: 'Ctrl + F', action: 'Search' },
  { key: 'Ctrl + R', action: 'Reports' },
  { key: 'Ctrl + ,', action: 'Settings' },
  { key: 'Shift + ?', action: 'Show shortcuts' },
];

function KeyboardShortcutsDialog() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === '?' && e.shiftKey) setOpen((o) => !o);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <ModalHeader>
        <div className="flex items-center gap-2">
          <Keyboard className="h-4 w-4 text-primary" />
          <ModalTitle>Keyboard Shortcuts</ModalTitle>
        </div>
        <ModalDescription>Press Shift + ? to toggle this dialog</ModalDescription>
      </ModalHeader>
      <ModalBody>
        <ul className="divide-y divide-border">
          {SHORTCUTS.map((s) => (
            <li
              key={s.key}
              className="flex items-center justify-between gap-4 py-2.5"
            >
              <kbd className="inline-flex items-center rounded border border-border bg-muted px-2 py-0.5 font-mono text-xs text-foreground shadow-sm">
                {s.key}
              </kbd>
              <span className="text-sm text-muted-foreground">{s.action}</span>
            </li>
          ))}
        </ul>
      </ModalBody>
    </Modal>
  );
}

export default KeyboardShortcutsDialog;
